import '../app.es6';
import angular from 'angular';

angular.module('myApp').factory('ConfiguredRestangular',
  ['Restangular', '$location', '$window', '$sessionStorage', '$timeout', 'LoginType',
  (Restangular, $location, $window, $sessionStorage, $timeout, LoginType) => {
    /* @ngInject */
    return Restangular.withConfig((RestangularConfigurer) => {
      // リクエストが成功した場合の共通処理
      RestangularConfigurer.addResponseInterceptor((data, operation, what, url, response, deferred) => {
        // 各種Flashメッセージのフラグをリセット
        resetErrorMessageFlag('hasSessionError');
        resetErrorMessageFlag('hasTokenError');
        resetErrorMessageFlag('hasPermissionError', 3000);
        return data;
      });

      // リクエストがエラーになった場合の共通処理
      RestangularConfigurer.setErrorInterceptor((resp, deferred, handler) => {
        // サーバから401(Unauthorized)が返ってきた場合
        if (resp.status === 401) {
          // サインインの試行失敗だった場合は何もしない
          if (resp.config.url === '/api/v1/sign-in') { return; }
          // エラーメッセージは認証が必要なページでのみ出す（本当はもっとうまいやり方でやりたい）
          let path = $location.path();
          if (!path.match(/\/login$/) && path.match(/^\/[pc]\//)) {
            // エラーメッセージを5秒間表示
            flashErrorMessageFlag('hasSessionError', 5000);
          }
          // $sessionStorage内のユーザ情報をクリア。
          $sessionStorage.user = null;
          // ユーザタイプ毎のサインインページへリダイレクト
          $location.path(`/${LoginType.getShorthand()}/login`);

        // サーバから403(Permission Denied)が返ってきた場合
        } else if (resp.status === 403) {
          // エラーメッセージを5秒間表示
          flashErrorMessageFlag('hasPermissionError', 5000);
          // 前のページに戻る
          // TODO: もしこの実装により問題があった場合は
          //        サインインページへのリダイレクト等で代替する。
          $window.history.back();

        // サーバから422(InvalidAuthenticityToken)が返ってきた場合
        } else if (resp.status === 422) {
          // Tokenを取り直す
          let request = Restangular.one('token');
          request.get().then(() => {
            // エラーメッセージを3秒間表示
            flashErrorMessageFlag('hasTokenError', 3000);
          });
        }
      });
    });

    // 指定されたフラッシュメッセージ用のフラグをfalseに設定する。
    function resetErrorMessageFlag (flagName, msec) {
      msec = msec || 0;
      $timeout(() => {
        $sessionStorage[flagName] = false;
      }, msec);
    }

    // 指定されたフラッシュメッセージ用のフラグを指定ミリ秒の間だけtrueにする。
    function flashErrorMessageFlag (flagName, msec) {
      $sessionStorage[flagName] = true;
      $timeout(() => {
        $sessionStorage[flagName] = false;
      }, msec);
    }
  }]
);



// WEBPACK FOOTER //
// ./app/services/configured-restangular.es6